module.exports = __webpack_public_path__ + "static/media/MoImgSignInBg.bd906a8d.svg";